// extracted by mini-css-extract-plugin
export default {"items":"styles_items__KZ4gb"};